var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"16.12.2017"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h2',[_vm._v("Heute bekommst Du Besuch!")]),_c('p',{staticClass:"center"},[_vm._v(" Ich freu mich schon auf Dich! ♥ ")]),_c('hr'),_c('Gallery',{attrs:{"directory":"2017/16"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }